<section class="cz-evaluation-stepper">
  <form [formGroup]="czEvaluationForm" class="form">
    <div formArrayName="formArray">
      <div class="row">
        <mat-form-field class="col-xs-6 form-field">
          <mat-label [innerHTML]="'$evaluation_date_label' | translate"></mat-label>
          <input matInput [matDatepicker]="evalDatePicker" [formControl]="evaluationDateControl" required>
          <mat-datepicker-toggle matSuffix [for]="evalDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #evalDatePicker></mat-datepicker>
          <mat-error class="error" [innerHTML]="'$evaluation_date_help_message' | translate"></mat-error>
          <mat-hint *ngIf="!readOnly">*<span [innerHTML]="'$common_required_field' | translate"></span></mat-hint>
        </mat-form-field>
        <mat-form-field class="col-xs-6 form-field" >
          <mat-label [innerHTML]="'$evaluation_assessed_by_label' | translate"></mat-label>
          <mat-select [formControl]="assessedByControl" required>
              <mat-select-trigger>{{assessedByControl.value ? assessedByControl.value.displayName : ''}}</mat-select-trigger>
            <mat-option *ngFor="let user of EvaladminUsers" [value]="user">
                <cz-user-select-item [user]="user"></cz-user-select-item>
            </mat-option>
          </mat-select>
          <mat-error class="error" [innerHTML]="'$common_required_field' | translate"></mat-error>
          <mat-hint *ngIf="!readOnly">*<span [innerHTML]="'$common_required_field' | translate"></span></mat-hint>
        </mat-form-field>
      </div>
      <div class="row">
        <ng-container *ngFor="let page of ergoEvalDetailsGroup; let a = index">
          <ng-container [formGroupName]="a">
            <ng-container *ngFor="let questionGroup of page.questionGroups"
              [formGroup]="formArray.get([formArray.length - 2])">
              <mat-form-field class="col-xs-6 form-field" *ngFor="let question of questionGroup.questions">
                <ng-container [formGroupName]="questionGroup.id">
                  <mat-select [placeholder]="question.label" [formControlName]="question.id">
                    <mat-option *ngFor="let answer of question.answers" [value]="answer">{{answer.label}}</mat-option>
                  </mat-select>
                </ng-container>
              </mat-form-field>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngFor="let page of ergoEvalWorkAreaGroup; let a = index">
          <ng-container [formGroupName]="a">
            <ng-container *ngFor="let questionGroup of page.questionGroups"
              [formGroup]="formArray.get([formArray.length - 1])">
              <mat-form-field class="col-xs-6 form-field" *ngFor="let question of questionGroup.questions">
                <ng-container [formGroupName]="questionGroup.id">
                  <mat-select [placeholder]="question.label" [formControlName]="question.id" required>
                    <mat-option *ngFor="let answer of question.answers" [value]="answer">{{answer.label}}</mat-option>
                  </mat-select>
                </ng-container>
              </mat-form-field>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="row bottom-xs">
        <div class="section-heading col-xs-8">
          <h2 class="h1 section-header no-margin" [innerHTML]="'$common_ergonomic_evaluation' | translate"></h2>
          <p class="no-margin" [innerHTML]="'$evaluation_ergonomic_evaluation_introduction' | translate"></p>
          <p class="no-margin" [innerHTML]="'$evaluation_exec_summary_save_note' | translate"></p>
        </div>
        <div class="col-xs-4 end-xs">
            <button mat-button (click)="openAll()" *ngIf="!panelOpenState" [innerHTML]="'$btn_expand_all' | translate"></button>
            <button mat-button (click)="closeAll()" *ngIf="panelOpenState" [innerHTML]="'$btn_collapse_all' | translate"></button>
            <button mat-button (click)="toggleSelectAll()">
              {{ isAllSelected ? ('$common_deselect_all' | translate) : ('$common_select_all' | translate) }}
            </button>
        </div>
      </div>
      <mat-accordion #myaccordion="matAccordion" class="ergonomic-assessment-review-panels" multi="true">

        <!-- ERGO EVALUATION PAGES -->
        <mat-expansion-panel class="ergo-recommendation-summary" *ngFor="let page of ergoEvalPageGroup; let x = index">
          <mat-expansion-panel-header>
            <mat-panel-title class="truncate">
              {{page.title}}
            </mat-panel-title>
            <mat-panel-description>
              <mat-checkbox labelPosition="before" 
                            (click)="stopPropagation($event)" 
                            (change)="checkboxInteraction($event, page.id)"
                            [checked]="updatedEvaluation.printPages.includes(page.id)">{{'$evaluation_add_to_report_label' | translate}}</mat-checkbox>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div [formGroupName]="x">
            <div *ngIf="page.questionGroups.length > 0">
              <!-- loop through questionGroups -->
              <div *ngFor="let questionGroup of page.questionGroups" class="row" [ngClass]="questionGroup.id">
                <div *ngIf="hasSpecialText(questionGroup.id)" class="special-label">
                  {{getSpecialText(questionGroup.id)}}
                </div>
                <div *ngIf="questionGroup.id !== 'EPIC'" class="secondaryRow">
                  <!-- loop through questions -->
                  <div *ngFor="let question of questionGroup.questions; let i = index" class="questionId">
                    <cz-dynamic-question-content [type]="questionGroup.id"
                                                 [question]="question"
                                                 [form]="formArray.get([x])"
                                                 [imagePath]="evaluationImagePath"
                                                 [index]="i"
                                                 [readOnly]="readOnly">
                    </cz-dynamic-question-content>
                  </div>
                </div>

                <!-- photo upload -->
                <div *ngIf="questionGroup.id === 'EPIC'" class="col-xs-12">
                    <h5 class="no-margin" *ngIf="!readOnly" [innerHTML]="'$photo_upload_photo_upload_introduction' | translate"></h5>
                    <div class="section-image-uploading">
                      <div class="col-xs-12">
                        <cz-photo-upload [placeholderImage]="placeholderImage"
                                         [parentComponent]="componentName"
                                         [questionGroup]="questionGroup"
                                         [form]="formArray.get([x])"
                                         [userId]="userId"
                                         [readOnly]="readOnly"
                                         [type]="questionGroup.id"
                                         (photoRemoved)="photoRemoved($event)">
                        </cz-photo-upload>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div *ngIf="page.questionGroups.length <= 0 && page.id !== '2-1'">
              <!-- since we're using page.id here, we'll have to account for that in the dynamic content component -->
              <cz-dynamic-question-content [type]="page.id"
                                           [question]="null"
                                           [form]="null"
                                           [imagePath]="evaluationImagePath"
                                           [entity]="evaluation"
                                           [currentUser]="currentUser"
                                           [userId]="userId"
                                           [recommendationTemplates$]="recommendationTemplates$"
                                           [readOnly]="readOnly"
                                           [recommendations$]="recommendations$"
                                           [equipmentList$]="equipmentList$"
                                           [equipmentRecommendations$]="equipmentRecommendations$"
                                           (equipmentOrderUpdated)="forwardEquipmentOrderUpdated($event)">
              </cz-dynamic-question-content>
            </div>
            <div *ngIf="page.questionGroups.length <= 0 && page.id === '2-1'">
                <!-- Recommendations are a special case so we need to reference their component directly -->
                <cz-ergonomic-recommendations [entity]="evaluation"
                                              [currentUser]="currentUser"
                                              [userId]="userId"
                                              [recommendationTemplates$]="recommendationTemplates$"
                                              [readOnly]="readOnly"
                                              [recommendations$]="recommendations$"
                                              [saved$]="saved$"
                                              [noTranslate]="noTranslate"
                                              [cultureCookie]="cultureCookie"
                                              [backupLanguageId]="backupLanguageId"
                                              [form]="formArray.get([x])"
                                              (recommendationAdded)="forwardRecommendationAdded($event)"
                                              (recommendationUpdated)="forwardRecommendationUpdated($event)"
                                              (recommendationRemoved)="forwardRecommendationRemoved($event)">
                </cz-ergonomic-recommendations>
              </div>
          </div>
        </mat-expansion-panel>

        <!-- SURVEY ANSWER PAGES -->
        <div class="section-heading">
          <h2 class="h1 section-header" [innerHTML]="'$evaluation_survey_section_heading' | translate"></h2>
          <p class="no-margin" [innerHTML]="'$evaluation_survey_section_introduction' | translate"></p>
        </div>
        <ng-container *ngFor="let page of surveyAnswersPageGroup; let y = index">
          <mat-expansion-panel [stepControl]="formArray.get([y + (ergoEvalPageGroup.length)])">
            <mat-expansion-panel-header>
              <mat-panel-title class="truncate">
                {{page.title}}
              </mat-panel-title>
              <mat-panel-description>
                <mat-checkbox labelPosition="before" 
                              (click)="stopPropagation($event)" 
                              (change)="checkboxInteraction($event, page.id)"
                              [checked]="updatedEvaluation.printPages.includes(page.id)"><span [innerHTML]="'$evaluation_add_to_report_label' | translate"></span></mat-checkbox>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div [formGroupName]="y">
              <div *ngIf="page.questionGroups.length > 0">
                <!-- loop through questionGroups -->
                <div *ngFor="let questionGroup of page.questionGroups" class="row">
                  <div *ngIf="questionGroup.id !== 'DC' && questionGroup.id !== 'EPIC'" class="col-xs-12">
                    <!-- loop through questions -->
                    <div *ngFor="let question of questionGroup.questions">
                      <cz-dynamic-question-content [type]="questionGroup.id"
                                                   [question]="question"
                                                   [form]="formArray.get([y + (ergoEvalPageGroup.length)])"
                                                   [imagePath]="evaluationImagePath"
                                                   [readOnly]="readOnly">
                      </cz-dynamic-question-content>
                    </div>
                  </div>

                  <!-- we don't want multiple body charts for this question group -->
                  <div *ngIf="questionGroup.id === 'DC'" class="col-xs-12">
                    <cz-discomfort-body-diagram [data]="questionGroup"
                                                [form]="formArray.get([y + (ergoEvalPageGroup.length)])"
                                                [readOnly]="readOnly">
                    </cz-discomfort-body-diagram>
                  </div>
                 <!-- Photo Upload latest -->

                  <!-- photo upload -->
                  <div *ngIf="questionGroup.id === 'EPIC'" class="col-xs-12">
                    <h5 class="no-margin" *ngIf="!readOnly" [innerHTML]="'$photo_upload_photo_upload_introduction' | translate"></h5>
                    <div class="section-image-uploading">
                      <div class="col-xs-12">
                        <cz-photo-upload [placeholderImage]="placeholderImage" [parentComponent]="componentName"
                          [questionGroup]="questionGroup" 
                          [form]="formArray.get([y + (ergoEvalPageGroup.length)])" 
                          [userId]="userId" 
                          [readOnly]="readOnly"
                          [type]="questionGroup.id" 
                          (photoRemoved)="photoRemoved($event)">
                        </cz-photo-upload>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div *ngIf="page.questionGroups.length <= 0">
                <!-- since we're using page.id here, we'll have to account for that in the dynamic content component -->
                <cz-dynamic-question-content [type]="page.id"
                                             [question]="null"
                                             [form]="null"
                                             [imagePath]="evaluationImagePath"
                                             [entity]="evaluation"
                                             [userId]="userId"
                                             [readOnly]="readOnly">
                </cz-dynamic-question-content>
              </div>
            </div>
          </mat-expansion-panel>
        </ng-container>

        <!-- EQUIPMENT EVALUATION SECTION -->
        <div class="section-heading">
          <h2 class="h1 section-header" [innerHTML]="'$equipment_evaluation_section_title' | translate"></h2>
          <p class="no-margin" [innerHTML]="'$equipment_evaluation_section_description' | translate"></p>
        </div>
        <mat-expansion-panel *ngFor="let page of equipmentEvalPageGroup; let z = index">
          <mat-expansion-panel-header>
            <mat-panel-title class="truncate">
              {{page.title}}
            </mat-panel-title>
            <mat-panel-description>
              <mat-checkbox labelPosition="before" 
                            (click)="stopPropagation($event)" 
                            (change)="checkboxInteraction($event, page.id)"
                            [checked]="updatedEvaluation.printPages.includes(page.id)">{{'$evaluation_add_to_report_label' | translate}}</mat-checkbox>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div [formGroupName]="z">
            <div *ngIf="page.questionGroups.length > 0">
              <!-- loop through questionGroups -->
              <div *ngFor="let questionGroup of page.questionGroups" class="row" [ngClass]="questionGroup.id">
                <div *ngIf="hasSpecialText(questionGroup.id)" class="special-label">
                  {{getSpecialText(questionGroup.id)}}
                </div>
                <div *ngIf="questionGroup.id !== 'EPIC'" class="secondaryRow">
                  <!-- loop through questions -->
                  <div *ngFor="let question of questionGroup.questions; let i = index" class="questionId">
                    <cz-dynamic-question-content [type]="questionGroup.id"
                                                 [question]="question"
                                                 [form]="formArray.get([z + (ergoEvalPageGroup.length) + (surveyAnswersPageGroup.length)])"
                                                 [imagePath]="evaluationImagePath"
                                                 [index]="i"
                                                 [readOnly]="readOnly">
                    </cz-dynamic-question-content>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>


        <!-- EVALUATION EQUIPMENT SECTION -->
        <div class="section-heading">
          <h2 class="h1 section-header" [innerHTML]="'$evaluation_equipment' | translate"></h2>
          <p class="no-margin" [innerHTML]="'$evaluation_equipment_desc' | translate"></p>
        </div>
        <cz-user-details-equipment  *ngIf="this.evaluation && this.evaluation.subject.id > 0"
                                    [userId]="evaluation.subject.id"
                                    [esppId]="evaluation.id"
                                    [headerCheckedState]="updatedEvaluation.printPages.includes('equipment')"
                                    (headerChecked)="checkboxInteraction($event, 'equipment')"></cz-user-details-equipment>

        <!-- EVALUATION REVIEW PAGES -->
        <!-- <div class="section-heading">
          <h2 class="h1 section-header" [innerHTML]="'$evaluation_eval_review_section_heading' | translate"></h2>
          <p class="no-margin" [innerHTML]="'$evaluation_eval_review_section_introduction' | translate"></p>
        </div>
        <ng-container *ngFor="let page of evaluationReviewPageGroup; let z = index">
          <mat-expansion-panel [stepControl]="formArray.get([z + (ergoEvalPageGroup.length + surveyAnswersPageGroup.length)])">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{page.title}}
              </mat-panel-title>
              <mat-panel-description>
                <mat-checkbox labelPosition="before" (click)="stopPropagation($event)" (change)="checkboxInteraction($event, page.id)">Add to report</mat-checkbox>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div [formGroupName]="z">
              <div *ngIf="page.questionGroups.length <= 0"> -->
                <!-- since we're using page.id here, we'll have to account for that in the dynamic content component -->
                <!--<cz-dynamic-question-content [type]="page.id"
                                             [question]="null"
                                             [form]="null"
                                             [imagePath]="evaluationImagePath"
                                             [entity]="evaluation"
                                             [currentUser]="currentUser"
                                             [readOnly]="readOnly"
                                             [reviews$]="reviews$"
                                             (reviewAdded)="forwardReviewAdded($event)"
                                             (reviewUpdated)="forwardReviewUpdated($event)"
                                             (reviewRemoved)="forwardReviewRemoved($event)">
                </cz-dynamic-question-content>
              </div>
            </div>
          </mat-expansion-panel>
        </ng-container> -->
      </mat-accordion>
      <div class="row bottom-buttons">
        <div class="col-xs-7">
          <button mat-stroked-button class="save-button" (click)="saveEvaluation()" *ngIf="!readOnly" [innerHTML]="'$btn_save' | translate"></button>
          <button mat-stroked-button (click)="openPdfDialog()" class="generate-report-button" [innerHTML]="'$btn_pdf_report' | translate"></button>
        </div>
        <!-- <div class="col-xs-3 end-xs">
         <button mat-stroked-button class="save-button" (click)="openTaskDialog()" *ngIf="!readOnly"  >REASSIGN</button>
          
        </div> -->
        <div class="col-xs-5 end-xs">
          <button mat-flat-button color="accent" type="submit" (click)="completeEvaluationDialog()" class="complete-evaluation-button" *ngIf="!readOnly" [innerHTML]="'$btn_complete_evaluation' | translate">
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-7">
          <p [innerHTML]="'$evaluation_save_evaluation_copy' | translate"></p>
        </div>
      </div>
    </div>
  </form>
</section>
